import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function TopBar({ onMenuClick }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="top-bar">
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <button 
          className="menu-toggle-btn"
          onClick={onMenuClick}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            display: 'none', // Hidden by default, shown in CSS for mobile
            color: '#1d2b64'
          }}
        >
          &#9776;
        </button>
        <div className="breadcrumbs">
          <span>DELTA MEDIA</span>
          <span style={{ color: 'var(--muted)' }}>|</span>
          <span>Booking Management System</span>
        </div>
      </div>
      <div className="top-actions">
        <button 
          className="btn-primary" 
          onClick={() => navigate('/create')}
          style={{ 
            padding: '0.5rem 1.2rem', 
            borderRadius: '0.5rem', 
            fontSize: '0.85rem', 
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
        >
          <span>+</span> <span className="btn-text">New Booking</span>
        </button>
        <div className="user-profile-section" style={{ display: 'flex', alignItems: 'center', gap: '1.2rem', marginLeft: '1rem', paddingLeft: '1.5rem', borderLeft: '1px solid #e2e8f0' }}>
          <div className="user-info-text" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.95rem', textTransform: 'capitalize' }}>
              {user?.name || user?.email?.split('@')[0] || 'User'}
            </span>
            <span style={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 500 }}>
              {user?.role || 'Member'}
            </span>
          </div>
          <button
            className="btn-secondary logout-btn"
            style={{ 
              padding: '0.5rem 1.2rem', 
              borderRadius: '2rem',
              fontSize: '0.85rem',
              fontWeight: 600,
              color: '#fff',
              background: '#1c4fe0',
              border: 'none',
              boxShadow: '0 4px 12px rgba(28, 79, 224, 0.15)'
            }}
            onClick={logout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

